export const DueDateEnum = {
    overdueTodos: 0,
    todaysTodos: 1,
    tomorrowsTodos: 2,
    thisWeeksTodos: 3,
    nextWeeksTodos: 4,
    tasksWithNoDueDate: 5,
    projectsWithNoDueDate: 6,
};